import strings from '../strings';


//The most recent lesson result is kept in localStorage so it never leaves the browser.
//Storage can be unavailable (private windows, blocked site data), so failures are ignored
//and the results section simply shows nothing.
export function saveLastResult(result){
    try {
        localStorage.setItem(strings.LAST_RESULTS_KEY, JSON.stringify(result));
    } catch (e) {
        //Nothing to do: the result just will not be remembered.
    }
};


export function loadLastResult(){
    try {
        const saved = localStorage.getItem(strings.LAST_RESULTS_KEY);
        if(saved !== null)
            return JSON.parse(saved);

        return migrateLastResultCookie();
    } catch (e) {
        return null;
    }
};


//Results used to be saved in a cookie. Move an existing one into localStorage and remove it.
function migrateLastResultCookie(){
    const prefix = `${strings.LAST_RESULTS_KEY}=`;
    const cookie = document.cookie.split('; ').find((c) => c.startsWith(prefix));
    if(cookie === undefined)
        return null;

    document.cookie = `${prefix}; path=/; max-age=0`;
    const result = JSON.parse(decodeURIComponent(cookie.slice(prefix.length)));
    saveLastResult(result);
    return result;
};
